import { Map } from "immutable";
import { ApprovalFlowModel } from "models/ApprovalFlowModel";
import { apiReq } from "utils/api/apiReq";

export const getApprovalFlow = async (id: string) => {
  if (!id) {
    throw new Error("Approval flow id is required");
  }
  const { data } = await apiReq<unknown[]>("GET", `/v1/approvalFlows/${id}`);

  return ApprovalFlowModel.fromServerData(data);
};

export const getApprovalFlows = async (): Promise<Map<string, ApprovalFlowModel>> => {
  const { data } = await apiReq<unknown[]>("GET", "/v1/approvalFlows");

  return Map(
    data
      .map((approvalFlow: unknown) => ApprovalFlowModel.fromServerData(approvalFlow))
      .map((approvalFlow: ApprovalFlowModel) => [approvalFlow.id, approvalFlow]),
  );
};
